import React, { useState } from 'react'
import { HumanTime } from '@/components/commons/HumanTime'
import contactsService from '@/app-domains/contacts/contacts.service'
import NameSlugPlaceholder from '@/pages/HomePage/FeedContent/Thread/CardMainSection/MainSectionHeader/NameSlugPlaceholder'

import './styles.sass'

export function NotificationHeader ({ message }) {
  const { date, fromEmailOnlyName, fromEmail } = message
  const [contact] = useState(contactsService.findContactByEmail(fromEmail) || contactsService.getPersonalInfoIfMailComesFromCustomer(fromEmail))

  const getGenericProfileImage = () => {
    return <div className="-img">
      { fromEmailOnlyName && <NameSlugPlaceholder name={fromEmailOnlyName}/> }
      { !fromEmailOnlyName && <img src="https://via.placeholder.com/40" className="senderInformationPhotoStyle"></img> }
    </div>
  }
  
  const getProfileImage = () => {
    return <div className="-img" onClick={() => contact && contactsService.travelToContactViewAndFocusContact(contact)}>
      { contact?.contactimageuri
        ? <img className='contact-image-img' src={contact.contactimageuri}/>
        : <NameSlugPlaceholder name={
            contactsService.buildContactFullname(contact)
        }/>}
    </div>
  }

  return <section className="NotificationSectionHeader">
    <div className="-sender">
      <div className="-img">
        {contact ? getProfileImage() : getGenericProfileImage()}
      </div>
      <div className="-details">
        <div className="-name">{fromEmailOnlyName}</div>
        <div className="-time">
          { date && <HumanTime date={date}/> }
        </div>
      </div>
    </div>
  </section>
}
